import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { LetsWorkTogether } from "./Components/lets-work-section";

import AdminApp from "./admin/AdminApp";

export default function App() {
  return (
    <Routes>
      {/* Public website */}
      <Route path="/" element={<LetsWorkTogether />} />

      {/* Admin app (handles /admin-login and /admin internally) */}
      <Route path="/*" element={<AdminApp />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
